import * as React from 'react';

import s from './Content.module.scss';
import { DndUploader } from './components/DndUploader';
import { Header } from './components/Header';

const Content: React.FC = () => {
  return (
    <div className={s['content']}>
      <Header />
      <div className={s['content__uploader']}>
        <DndUploader />
      </div>
    </div>
  );
};

export default React.memo(Content);
